
import IndustryRoiTable from "./IndustryRoiTable";

const IndustryRoi = () => {
  return <IndustryRoiTable />;
};

export default IndustryRoi;
